const displayHtml = props => {
  return {__html: props}
}

const getDate = (input) => {
  const date = new Date(input)
  const month = date.getMonth()
  const day = date.getDate()
  const year = date.getFullYear()
  const dateNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  const fullDate = dateNames[month] + ' ' + day + ', ' + year

  return fullDate
}

const get_fiscal_year = () => {
  const date = new Date();
  const month = date.getMonth();
  const year = date.getFullYear();

  //If October onwards it will return nex year
  const fiscal_year = (month >= 9) ? (year + 1) : year;

  return fiscal_year;
}

export { displayHtml, getDate, get_fiscal_year }